angular.module('zc.projects')

.controller 'VisitorIdForDMUploadCtrl', ($scope, $stateParams, Project) ->

  $scope.$on 'flow::fileAdded', (event, $flow, flowFile) ->
    event.preventDefault()
    Project.uploadVisitorIdsForDM
      projectId: $stateParams.projectId
    ,
      file: flowFile.file
    .then (visitorIdsForDM) ->
      $scope.$parent.visitorIdsForDM =  visitorIdsForDM



// WEBPACK FOOTER //
// ./src/zenclerk_modules/projects/controllers/visitor_id_for_dm_upload.controller.coffee